module.exports = __webpack_public_path__ + "static/img/yjzx.2538eee.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/yjzx.png
// module id = tAe4
// module chunks = 33